"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "bufferTransform", {
    enumerable: true,
    get: function() {
        return bufferTransform;
    }
});
const _stream = require("stream");
function bufferTransform() {
    const chunks = [];
    return {
        get buffer () {
            return chunks.join("");
        },
        transform: new _stream.Transform({
            transform (chunk, encoding, callback) {
                chunks.push(chunk.toString());
                callback();
            }
        })
    };
}
